<template>
  <div>
    <div class="afdc-custom-control afdc-custom-checkbox">
      <input type="checkbox" v-model="queryLpgSecondary" class="afdc-custom-control-input" v-bind:aria-describedby="`afdc-find-lpg-secondary-help-${uniqueId}`" v-bind:id="`afdc-find-lpg-secondary-${uniqueId}`" aria-controls="afdc-results-count">
      <label class="afdc-custom-control-label" v-bind:for="`afdc-find-lpg-secondary-${uniqueId}`">{{ $t("Include stations with limited vehicle fueling") }}</label>
    </div>
    <p class="afdc-input-note" v-bind:id="`afdc-find-lpg-secondary-help-${uniqueId}`">{{ $t("These stations have fuel available for use in vehicles but limited vehicle fueling services.") }}</p>
  </div>
</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  data() {
    return {
      uniqueId: null,
    };
  },

  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.uniqueId = this._uid;
  },

  computed: {
    queryLpgSecondary: syncInputRouteQuery('lpg_secondary'),
  },
};
</script>

<style lang="scss">
</style>
